import React, { useState } from "react";
import api from "../../../../services/api";
import { fmtDateFull, fmtNum } from "../../../../shared/utils";
export default function AdminQuestoes(props) {
  const institutionContext = props.institutionContext;
  const institutionApi = institutionContext?.http || api;
  let checkpoints = props.checkpoints;
  let setCheckpoints = props.setCheckpoints;
  let students = props.students;
  let activities = props.activities;
  let showFlash = props.showFlash;
  const [decidindo, setDecidindo] = useState(null);
  const pend = checkpoints.filter(
    (checkpoint) => "pendente" === checkpoint.status_questao,
  );
  const hist = checkpoints.filter((checkpoint) =>
    ["invalido", "valido", "reduzido"].includes(checkpoint.status_questao),
  );
  const decidirQuestionamento = async function (
    item,
    endpoint,
    payload,
    successMessage,
    tipo = "ok",
  ) {
    try {
      const responseData2 = await institutionApi.post(endpoint, {
        checkpoint_id: item.id,
        ...payload,
      });
      const saved = responseData2.data?.data ?? responseData2.data;
      setCheckpoints(
        checkpoints.map((checkpoint) =>
          checkpoint.id === item.id ? saved : checkpoint,
        ),
      );
      showFlash(successMessage, tipo);
      setDecidindo(null);
    } catch (err) {
      showFlash(
        err.response?.data?.message || "Nao foi possivel registrar a decisao.",
        "er",
      );
    }
  };
  const aplicar = async (resultado, tipo) => {
    const resultadoAtual2 = decidindo || {};
    if ("invalido" === tipo)
      await decidirQuestionamento(
        resultado,
        "/checkpoints/invalidar-questionamento",
        {
          motivo: resultadoAtual2.motivo || "",
        },
        "Checkpoint invalidado. Pontuação zerada.",
        "er",
      );
    else {
      const rPts = Math.max(0, parseInt(resultadoAtual2.reducPts) || 0);
      const rTok = Math.max(0, parseInt(resultadoAtual2.reducTok) || 0);
      await decidirQuestionamento(
        resultado,
        "/checkpoints/reduzir-questionamento",
        {
          reducao_pontos: rPts,
          reducao_tokens: rTok,
          motivo: resultadoAtual2.motivo || "",
        },
        "Pontuação ajustada: -"
          .concat(rPts, " pontos / -")
          .concat(rTok, " tokens."),
        "in",
      );
    }
  };
  return (
    <div>
      <div className={"dv dv-dark"}>
        <span>
          {"Denúncias Pendentes ("}
          {institutionContext ? props.pendingCount : pend.length}
          {")"}
        </span>
      </div>
      {0 === pend.length ? (
        <div className={"es"}>
          <h3>{"Nenhuma denúncia pendente"}</h3>
          <p>{"Quando alunos questionarem checkpoints, aparece aqui."}</p>
        </div>
      ) : (
        pend.map((pendAluno_id) => {
          const student = students.find(
            (studentId) => studentId.id === pendAluno_id.aluno_id,
          );
          const den = students.find(
            (studentId) => studentId.id === pendAluno_id.questionado_por,
          );
          const aberto = decidindo?.cpId === pendAluno_id.id;
          return (
            <div
              className={"fc"}
              style={{
                marginBottom: 12,
              }}
              key={pendAluno_id.id}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  marginBottom: 8,
                }}
              >
                <div>
                  <div
                    style={{
                      fontWeight: 800,
                      color: "#1F4754",
                      fontSize: 14,
                    }}
                  >
                    {student?.nome}
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "#6B8590",
                      marginTop: 2,
                    }}
                  >
                    {fmtDateFull(pendAluno_id.data_estudo)}
                  </div>
                </div>
                <div
                  style={{
                    textAlign: "right",
                  }}
                >
                  <div
                    style={{
                      fontSize: 13,
                      fontWeight: 800,
                      color: "#FF8C42",
                    }}
                  >
                    {fmtNum(pendAluno_id.pontos_rank || 0)}
                    {" pontos"}
                  </div>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: 700,
                      color: "#4FB3A9",
                    }}
                  >
                    {fmtNum(pendAluno_id.tokens || 0)}
                    {" tokens"}
                  </div>
                </div>
              </div>
              <div
                style={{
                  background: "#FFF8E0",
                  borderRadius: 8,
                  padding: "8px 11px",
                  marginBottom: 8,
                  border: "1px solid #F59E0B",
                }}
              >
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#856404",
                    marginBottom: 3,
                  }}
                >
                  {"Denúncia de: "}
                  {den?.nome || "?"}
                </div>
                {pendAluno_id.justificativa_questao && (
                  <div
                    style={{
                      fontSize: 12,
                      color: "#6B4C00",
                      lineHeight: 1.5,
                    }}
                  >
                    {'"'}
                    {pendAluno_id.justificativa_questao}
                    {'"'}
                  </div>
                )}
              </div>
              <div
                className={"al"}
                style={{
                  marginBottom: 8,
                }}
              >
                {pendAluno_id.itens.map((iten, index) => {
                  const activity = activities.find(
                    (activityId) => activityId.id === iten.tipo_id,
                  );
                  return (
                    <div
                      className={"ai"}
                      style={{
                        borderLeftColor: activity?.cor || "#CCC",
                      }}
                      key={index}
                    >
                      <div>
                        <div className={"ail"}>{activity?.nome}</div>
                        <div className={"aiq"}>
                          {iten.quantidade} {activity?.unidade}
                          {"s"}
                        </div>
                      </div>
                      <div className={"aip"}>
                        <div className={"rank"}>
                          {"+"}
                          {fmtNum(iten.pts_rank || 0)}
                          <small>{"Pontos"}</small>
                        </div>
                        <div className={"tok"}>
                          {"+"}
                          {fmtNum(iten.pts_token || 0)}
                          <small>{"Tokens"}</small>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              {pendAluno_id.observacao && (
                <div
                  className={"obs"}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  {pendAluno_id.observacao}
                </div>
              )}
              {aberto ? (
                <div
                  style={{
                    background: "#F4F8F9",
                    borderRadius: 10,
                    padding: "12px",
                    border: "1.5px solid #D5DEE3",
                  }}
                >
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: 700,
                      color: "#1F4754",
                      marginBottom: 10,
                    }}
                  >
                    {"Redução de pontuação:"}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: 8,
                      marginBottom: 8,
                    }}
                  >
                    <div
                      style={{
                        flex: 1,
                      }}
                    >
                      <label
                        style={{
                          fontSize: 11,
                          fontWeight: 700,
                          color: "#1F4754",
                          display: "block",
                          marginBottom: 4,
                        }}
                      >
                        {"Reduzir Pontos"}
                      </label>
                      <input
                        type={"number"}
                        className={"inp"}
                        min={"0"}
                        max={pendAluno_id.pontos_rank || 0}
                        value={decidindo.reducPts}
                        placeholder={"Máx: ".concat(
                          pendAluno_id.pontos_rank || 0,
                        )}
                        onChange={(event) =>
                          setDecidindo({
                            ...decidindo,
                            reducPts: event.target.value,
                          })
                        }
                      />
                    </div>
                    <div
                      style={{
                        flex: 1,
                      }}
                    >
                      <label
                        style={{
                          fontSize: 11,
                          fontWeight: 700,
                          color: "#1F4754",
                          display: "block",
                          marginBottom: 4,
                        }}
                      >
                        {"Reduzir Tokens"}
                      </label>
                      <input
                        type={"number"}
                        className={"inp"}
                        min={"0"}
                        max={pendAluno_id.tokens || 0}
                        value={decidindo.reducTok}
                        placeholder={"Máx: ".concat(pendAluno_id.tokens || 0)}
                        onChange={(event) =>
                          setDecidindo({
                            ...decidindo,
                            reducTok: event.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      marginBottom: 8,
                    }}
                  >
                    <label
                      style={{
                        fontSize: 11,
                        fontWeight: 700,
                        color: "#1F4754",
                        display: "block",
                        marginBottom: 4,
                      }}
                    >
                      {"Motivo da decisão"}
                    </label>
                    <textarea
                      className={"tea"}
                      style={{
                        minHeight: 50,
                        fontSize: 12,
                      }}
                      value={decidindo.motivo}
                      placeholder={"Descreva o motivo..."}
                      onChange={(event) =>
                        setDecidindo({
                          ...decidindo,
                          motivo: event.target.value,
                        })
                      }
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: 6,
                    }}
                  >
                    <button
                      className={"btn bor"}
                      style={{
                        flex: 1,
                        fontSize: 11,
                      }}
                      onClick={() => aplicar(pendAluno_id, "reduzido")}
                    >
                      {"Reduzir"}
                    </button>
                    <button
                      className={"btn bd"}
                      style={{
                        flex: 1,
                        fontSize: 11,
                      }}
                      onClick={() => aplicar(pendAluno_id, "invalido")}
                    >
                      {"Invalidar tudo"}
                    </button>
                    <button
                      className={"btn bg"}
                      style={{
                        flex: 1,
                        fontSize: 11,
                      }}
                      onClick={() => setDecidindo(null)}
                    >
                      {"Cancelar"}
                    </button>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    gap: 7,
                  }}
                >
                  <button
                    className={"btn"}
                    style={{
                      flex: 1,
                      fontSize: 12,
                    }}
                    onClick={() =>
                      (async (resultado) => {
                        await decidirQuestionamento(
                          resultado,
                          "/checkpoints/aprovar-questionamento",
                          {},
                          "Checkpoint de ".concat(
                            students.find(
                              (studentId) =>
                                studentId.id === resultado.aluno_id,
                            )?.nome,
                            " aprovado.",
                          ),
                          "ok",
                        );
                      })(pendAluno_id)
                    }
                  >
                    {"Aprovar"}
                  </button>
                  <button
                    className={"btn bor"}
                    style={{
                      flex: 1,
                      fontSize: 12,
                    }}
                    onClick={() =>
                      setDecidindo({
                        cpId: pendAluno_id.id,
                        reducPts: "",
                        reducTok: "",
                        motivo: "",
                      })
                    }
                  >
                    {"Penalizar"}
                  </button>
                  <button
                    className={"btn bd"}
                    style={{
                      flex: 1,
                      fontSize: 12,
                    }}
                    onClick={() => aplicar(pendAluno_id, "invalido")}
                  >
                    {"Invalidar"}
                  </button>
                </div>
              )}
            </div>
          );
        })
      )}
      {hist.length > 0 && (
        <HistoricoDecisoes
          hist={hist}
          students={students}
          activities={activities}
          statusInfo={{
            valido: {
              bg: "#E0F5F0",
              color: "#1A7A6E",
              txt: "Aprovado",
            },
            invalido: {
              bg: "#FFE5E0",
              color: "#B83A2E",
              txt: "Invalidado",
            },
            reduzido: {
              bg: "#FFF1DD",
              color: "#B8651E",
              txt: "Reduzido",
            },
          }}
        />
      )}
    </div>
  );
}
function HistoricoDecisoes({ hist, students, activities, statusInfo }) {
  const [aberto, setAberto] = useState(null);
  return (
    <div>
      <div className="dv dv-dark">
        <span>Histórico ({hist.length})</span>
      </div>
      {hist.map((item) => {
        const student = students.find(
          (studentAtual2) => studentAtual2.id === item.aluno_id,
        );
        const value = statusInfo[item.status_questao] || {
          bg: "#F0F4F6",
          color: "#6B8590",
          txt: item.status_questao,
        };
        const open = aberto === item.id;
        return (
          <div
            key={item.id}
            style={{
              marginBottom: 5,
            }}
          >
            <div
              onClick={() => setAberto(open ? null : item.id)}
              style={{
                background: "rgba(255,255,255,0.07)",
                borderRadius: open ? "9px 9px 0 0" : 9,
                padding: "9px 12px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: "rgba(255,255,255,0.85)",
                  }}
                >
                  {student?.nome} — {fmtDateFull(item.data_estudo)}
                </div>
                {(item.decisao_admin || item.justificativa_questao) && (
                  <div
                    style={{
                      fontSize: 11,
                      color: "rgba(255,255,255,0.45)",
                      marginTop: 2,
                    }}
                  >
                    {item.decisao_admin || item.justificativa_questao}
                  </div>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  flexShrink: 0,
                }}
              >
                <span
                  style={{
                    fontSize: 9,
                    fontWeight: 700,
                    padding: "3px 9px",
                    borderRadius: 999,
                    background: value.bg,
                    color: value.color,
                  }}
                >
                  {value.txt}
                </span>
                <span
                  style={{
                    color: "rgba(255,255,255,0.4)",
                    fontSize: 12,
                  }}
                >
                  {open ? "▲" : "▼"}
                </span>
              </div>
            </div>
            {open && (
              <div
                style={{
                  background: "rgba(255,255,255,0.04)",
                  borderRadius: "0 0 9px 9px",
                  padding: "10px 12px",
                  border: "1px solid rgba(255,255,255,0.07)",
                  borderTop: "none",
                }}
              >
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "rgba(255,255,255,0.5)",
                    textTransform: "uppercase",
                    letterSpacing: ".1em",
                    marginBottom: 7,
                  }}
                >
                  Itens do checkpoint
                </div>
                {item.itens.map((itemAtual2, index) => {
                  const activity = activities.find(
                    (activityAtual2) =>
                      activityAtual2.id === itemAtual2.tipo_id,
                  );
                  return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "4px 0",
                        borderBottom: "1px solid rgba(255,255,255,0.05)",
                        fontSize: 12,
                        color: "rgba(255,255,255,0.75)",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        <span
                          style={{
                            width: 7,
                            height: 7,
                            borderRadius: "50%",
                            background: activity?.cor || "#888",
                            display: "inline-block",
                          }}
                        />
                        {activity?.nome}
                      </span>
                      <span
                        style={{
                          fontWeight: 700,
                        }}
                      >
                        {itemAtual2.quantidade} {activity?.unidade}s —{" "}
                        {fmtNum(itemAtual2.pts_rank || 0)} pts /{" "}
                        {fmtNum(itemAtual2.pts_token || 0)} tok
                      </span>
                    </div>
                  );
                })}
                {item.observacao && (
                  <div
                    style={{
                      fontSize: 11,
                      color: "rgba(255,255,255,0.5)",
                      fontStyle: "italic",
                      marginTop: 7,
                    }}
                  >
                    "{item.observacao}"
                  </div>
                )}
                <div
                  style={{
                    marginTop: 8,
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 12,
                    fontWeight: 800,
                  }}
                >
                  <span
                    style={{
                      color: "#FF8C42",
                    }}
                  >
                    {fmtNum(item.pontos_rank || 0)} Pontos
                  </span>
                  <span
                    style={{
                      color: "#4FB3A9",
                    }}
                  >
                    {fmtNum(item.tokens || 0)} Tokens
                  </span>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
export { AdminQuestoes };
